import React from "react";
import cn from "classnames";
import styles from "./AddressInformation.module.sass";
import Card from "../../../components/Card";
import TextInput from "../../../components/TextInput";

const AddressInformation = ({ className, data, updateData, currentStep }) => {
  // Utiliser directement les données de l'étudiant transmises par le parent
  const studentData = data?.student || {};

  // Gestionnaires pour les changements de données
  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    
    // Mettre à jour les données d'adresse
    if (updateData) {
      updateData('addressInfo', { ...data.addressInfo, [name]: value });
    }
  };

  // Fusionner les données de l'étudiant avec les modifications en cours
  const currentData = { ...studentData, ...data.addressInfo };

  return (
    <Card className={cn(styles.card, className)} title="Adresse de l'étudiant" classTitle="title-green">
      <div className={styles.group}>
        <TextInput
          className={styles.field}
          label="Adresse"
          name="address"
          type="text"
          placeholder="123 rue de l'exemple"
          value={currentData?.address || ''}
          onChange={handleStudentChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="address_complement"
          type="text"
          placeholder="Appartement, étage..."
          value={currentData?.address_complement || ''}
          onChange={handleStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Code Postal"
          name="zip_code"
          type="text"
          placeholder="75001"
          value={currentData?.zip_code || ''}
          onChange={handleStudentChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="city"
          type="text"
          placeholder="Paris"
          value={currentData?.city || ''}
          onChange={handleStudentChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="country"
          type="text"
          placeholder="France"
          value={currentData?.country || ''}
          onChange={handleStudentChange}
          required
        />
      </div>
    </Card>
  );
};

export default AddressInformation;
